import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalculator, FiTrendingUp } = FiIcons;

const Header = () => {
  return (
    <motion.header 
      className="bg-white shadow-lg border-b border-gray-200"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        <div className="flex items-center justify-center space-x-3">
          <div className="bg-blue-600 p-3 rounded-lg">
            <SafeIcon icon={FiCalculator} className="text-white text-2xl" />
          </div>
          <div className="text-center">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
              Profitability Calculator
            </h1>
            <p className="text-gray-600 text-sm md:text-base">
              For Independent Consultants
            </p>
          </div>
          <div className="bg-green-600 p-3 rounded-lg">
            <SafeIcon icon={FiTrendingUp} className="text-white text-2xl" />
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;